import { HistoryStore as BaseHistoryStore } from '@bn-games/history-core';
import type { GameRecord } from './types.js';
import {
  HISTORY_CAP,
  HISTORY_SCHEMA_VERSION,
  HISTORY_STORAGE_KEY,
} from './types.js';

// Per-app subclass pre-configures @bn-games/history-core's generic FIFO list
// with sudoku's storage key + schema version + shape predicate + 50-record cap.
// The base store already drops the oldest on overflow (newest-first sort by
// `finishedAt`).
export class HistoryStore extends BaseHistoryStore<GameRecord> {
  constructor() {
    super({
      storageKey: HISTORY_STORAGE_KEY,
      schemaVersion: HISTORY_SCHEMA_VERSION,
      cap: HISTORY_CAP,
      isValid: (parsed) =>
        typeof parsed.seed === 'number' &&
        typeof parsed.difficulty === 'string' &&
        typeof parsed.timeMs === 'number',
    });
  }
}
